import React, { FC, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './_styles.header.css';
import { FaArrowLeft, FaHome } from 'react-icons/fa';
import { motion } from 'framer-motion';

interface HeaderProps {
  title: string;
  useBlur?: boolean;
  showHome?: boolean;
}

const Header: FC<HeaderProps> = ({
  title,
  useBlur = true,
  showHome = true,
}) => {
  const navigate = useNavigate();
  const [, setBlur] = useState('none');

  const changeNavbarColor = () => {
    if (window.scrollY >= 1) {
      setBlur('md');
    } else {
      setBlur('none');
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', changeNavbarColor);

    return () => {};
  }, []);

  const [isTimedOut, setIsTimedOut] = useState(false);

  const onButtonClick = () => {
    if (isTimedOut) {
      return;
    }

    navigate(-1);

    setIsTimedOut(true);

    setTimeout(() => {
      setIsTimedOut(false);
    }, 1000);
  };

  const onHomeClick = () => {
    navigate('/');
  };

  return (
    <motion.nav
      layout
      layoutId='header'
      className={`header ${useBlur ? 'blurBackground' : ''}`}
    >
      <div>
        <div className='flex align-middle gap-5'>
          <button onClick={onButtonClick} className='p-4 rounded-md'>
            <FaArrowLeft />
          </button>
          {showHome && (
            <button onClick={onHomeClick} className='p-4 rounded-md'>
              <FaHome />
            </button>
          )}
        </div>
        <motion.p layout layoutId='header-title'>
          {title}
        </motion.p>
      </div>
    </motion.nav>
  );
};

export default Header;
